export default {
  allphone: {
    pattern: /(^(\d{3,4}-)?\d{7,8})$|(^1(3|4|5|7|8)\d{9}$)/,
    msg: '电话或手机号格式不正确'
  },
  cellphone: {
    pattern: /^1(3|4|5|7|8)\d{9}$/,
    msg: '手机号格式不对'
  },
  postal: {
    pattern: /[1-9]\d{5}(?!\d)/,
    msg: '非法的邮政编码'
  },
  email: {
    pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
    msg: '非法的邮箱地址'
  },
  year: {
    pattern: /[0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3}/,
    msg: '年份格式为YYYY'
  },
  longtitude: {
    pattern: /^[\-\+]?(0?\d{1,2}\.\d{1,5}|1[0-7]?\d{1}\.\d{1,5}|180\.0{1,5})$/,
    msg: '经度格式为-180.0～+180.0（整数部分为0～180，必须输入1到5位小数）'
  },
  latitude: {
    pattern: /^[\-\+]?([0-8]?\d{1}\.\d{1,5}|90\.0{1,5})$/,
    msg: '纬度格式为-90.0～+90.0（整数部分为0～90，必须输入1到5位小数）'
  },
  identification18: {
    pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    msg: '请输入正确的18位身份证号'
  },
  identification15: {
    pattern: /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/,
    msg: '请输入正确的15位身份证号'
  },
  identification: {
    pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$|^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/,
    msg: '请输入正确的身份证号（15或18位）'
  },
  strongPwd: {
    pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]+$/,
    msg: '强：字母+数字+特殊字符'
  },
  midPwd: {
    pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]+$/,
    msg: '中：字母+数字，字母+特殊字符，数字+特殊字符'
  },
  weakPwd: {
    pattern: /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+)$/,
    msg: '弱：纯数字，纯字母，纯特殊字符'
  },
  webUrl: {
    pattern: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
    msg: '请输入正确的网站url地址(http等协议需要添加)'
  },
  positiveInteger: { // 0与正整数
    pattern: /^([1-9]\d*|[0]{1,1})$/,
    msg: '请输入正确的数字格式'
  },
  positiveIntegerNC0: { // 正整数
    pattern: /^[1-9]\d*$/,
    msg: '请输入正确的数字格式'
  }
}



// WEBPACK FOOTER //
// ./src/utils/validations.js